import {
  getMyobAuthorizationCallbackURL,
  getMyobAuthorizeURL,
  getmyobrefreshsoftwareUrl,
  getmyobspecificbookUrl,
  getmyobsyncinvoicesUrl
} from "../utils/constants/apiEndPoints";
import privateAxios from "../utils/axiosPrivate";

const useMyobApi = () => {
  const MyobAuthorize = async () => {
    const response = await privateAxios.get(getMyobAuthorizeURL);
    return response;
  };

  const MyobCallBack = async (bodyObj = {}) => {
    const response = await privateAxios.get(
      getMyobAuthorizationCallbackURL(bodyObj.code)
    );
    return response;
  };

  const MyobSelectSpecificBook = async (bodyObj = {}) => {
    return privateAxios.post(getmyobspecificbookUrl, bodyObj);
  };

  const MyobRefresh = async () => {
    return privateAxios.post(getmyobrefreshsoftwareUrl);
  };

  const MyobSyncInvoice = async () => {
    return privateAxios.post(getmyobsyncinvoicesUrl);
  };

  return {
    MyobAuthorize,
    MyobCallBack,
    MyobSelectSpecificBook,
    MyobRefresh,
    MyobSyncInvoice
  };
};

export default useMyobApi;
